module.exports = __webpack_public_path__ + "img/tamaishiki_logo.13764cd2.png";